import {Component, inject, Input} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {FloatLabel} from 'primeng/floatlabel';
import {InputText} from 'primeng/inputtext';
import {Question} from '../../../../../../models/Question';
import {ConsultationService} from '../../../../../../services/consultation.service';

@Component({
    selector: 'app-contact-details',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        InputText
    ],
    templateUrl: './contact-details.component.html',
    styleUrl: './contact-details.component.scss'
})
export class ContactDetailsComponent {

    // region Variables

    @Input() question: Question | null = null;
    public contactDetailsForm: FormGroup | undefined;
    private consultationService: ConsultationService = inject(ConsultationService);

    // endregion

    // Constructor
    constructor() {
    }

    // Init
    ngOnInit() {

        // Create Question Form
        this.contactDetailsForm = new FormGroup({
            firstName: new FormControl(this.question?.data?.firstName || '', [Validators.required]),
            lastName: new FormControl(this.question?.data?.lastName || '', [Validators.required]),
            email: new FormControl(this.question?.data?.email || '', [Validators.required])
        });

        // Listen To Form Changes
        this.contactDetailsForm.valueChanges.subscribe(value => {
            this.consultationService.updateSurveyQuestion(value, this.question);
        });

    }

    // Destroy
    ngOnDestroy() {
    }

}
